import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useTransferRefund = () => {
  return useMutation({
    mutationFn: (data) => api.referral.refund(data),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось отправить данные',
        description: error?.message,
        type: 'error',
      })
    }
  })
}
